import { render, staticRenderFns } from "./pondInputTab.vue?vue&type=template&id=7bf0ec51&"
import script from "./pondInputTab.vue?vue&type=script&lang=js&"
export * from "./pondInputTab.vue?vue&type=script&lang=js&"
import style0 from "./pondInputTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports